export class ExtensiblePromise {
    constructor() {
        this.promise = new Promise((resolve, reject) => {
            this._reject = reject;
            this._resolve = resolve;
        });
    }
    then(onfulfilled, onrejected) {
        return this.promise.then(onfulfilled, onrejected);
    }
    catch(onrejected) {
        return this.promise.catch(onrejected);
    }
}
/**
 * A Promise-Like class that can be controlled (resolved/rejected) via a public API
 */
export class ControlledPromise extends ExtensiblePromise {
    resolve(p) { this._resolve(p); }
    reject(e) { this._reject(e); }
}
export const delay = ms => new Promise(res => setTimeout(res, ms));
//# sourceMappingURL=promises.js.map